import {
    allowToBet,
    allowToSkip,
    autoBetCount,
    autoBetStarted,
    gameResult,
    gameRoundInfo,
    gameStatus,
    lastSelectedAutoBetCount,
    unformattedBalance,
    videoUrl
} from '@root/src/store';
import { EventEmitterInstance } from '../../utils/event-emitter';
import { get } from 'svelte/store';
import { showBonusGameTransition, showTopSlot } from '@root/src/store/ui';

export function waitForPlayClick(): Promise<string> {
    return new Promise(resolve => {
        EventEmitterInstance.once('play', () => {
            resolve('play');
        });
    });
}

export function waitEnd(): Promise<string> {
    return new Promise(resolve => {
        EventEmitterInstance.once('promise-end', () => {
            resolve('promise-end');
        });
    });
}

export function startAuto() {
    EventEmitterInstance.emit('play');
    autoBetStarted.set(true);
    autoBetCount.set(get(lastSelectedAutoBetCount) - 1);
}

export async function waitForBonusTransitionToFinish() {
    if (get(showBonusGameTransition)) {
        allowToBet.set(false);
        await waitForEmitterEvent('bonus-transition-finish');
        showBonusGameTransition.set(false);
    }
}

export async function applyTopSlotToBonusGame(timer = 1000) {
    const gameRound = get(gameRoundInfo);
    if (!gameRound?.resp?.top_slot || !gameRound?.resp?.ball_type) return;
    const ballType = gameRound?.resp?.ball_type;
    const selectedRightMutliplier = gameRound?.resp?.top_slot?.type;
    const isTopSlotAppliedToBonusGame = ballType === selectedRightMutliplier && gameRound?.resp?.win;

    if (isTopSlotAppliedToBonusGame) {
        await wait(timer);
        EventEmitterInstance.emit('top-slot-bonusTrigger');
        await wait(100);
        EventEmitterInstance.emit('bonusTriggerHit');
        await wait(timer);
    } else {
        await wait(0);
    }
    showTopSlot.set(false);
}

/** @param time in milliseconds */
export async function wait(time = 2000) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve('');
        }, time);
    });
}

export function waitForEvent(eventName: string): Promise<void> {
    return new Promise<void>(resolve => {
        function handler() {
            removeEventListener(eventName, handler);
            resolve();
        }
        addEventListener(eventName, handler);
    });
}

export function waitForEmitterEvent(eventName: string): Promise<void> {
    return new Promise<void>(resolve => {
        EventEmitterInstance.on(eventName, () => {
            resolve();
        });
    });
}

export const resetGameState = () => {
    gameStatus.set('NOT_STARTED');
    videoUrl.set(null);
    gameResult.set(null);
    allowToSkip.set(false);
    allowToBet.set(true);
};

export const updateBalance = () => {
    const $gameRoundInfo = get(gameRoundInfo);
    console.log('update balance ' + $gameRoundInfo?.balance);
    unformattedBalance.set($gameRoundInfo?.balance);
};

type IndexedResult<T> = { index: number; value?: T; error?: unknown };
export async function getIndexOfFirstResolved<T>(promises: Promise<T>[]): Promise<IndexedResult<T>> {
    const indexedPromises: Promise<IndexedResult<T>>[] = promises.map((promise, index) => {
        return promise.then(
            value => ({ index, value }),
            error => ({ index, error })
        );
    });
    return await Promise.race(indexedPromises);
}

/*
export async function loadRandomPlinkoPath() {
    const r = randomInteger(1, 9);
    const b = randomInteger(0, 12);
    const jsonFilePath = `assets/square_plinko/paths/${b}/${r}.b64`;

    const response = await fetch(jsonFilePath);
    const path = await response.text();
    if (!path) throw new Error('unable to load path: id ' + r);
    return path;
}
*/
